module.exports = require("@material-ui/core/colors/blue");